import { FormulaResult, PumpSizingFormData } from "../../../types/types";
import { parseNumericValue } from "../../helpers/helpers";

function getSumpArea(formData: PumpSizingFormData): number {
	const { sump } = formData.gpmData;

	if (sump.areaMode === "dimensions") {
		return (
			parseNumericValue(sump.length) *
			parseNumericValue(sump.width)
		);
	}

	return parseNumericValue(sump.areaSqft);
}

/**
 * Sump GPM = (area_sqft * 144 * rainfall_in / 231) / 60
 */
export function calculateSumpGpm(
	formData: PumpSizingFormData,
): FormulaResult {
	const area = getSumpArea(formData);
	const rainfall = parseNumericValue(formData.gpmData.sump.rainfall);

	if (area <= 0) {
		throw new Error("Enter a valid area to calculate GPM.");
	}

	if (rainfall <= 0) {
		throw new Error("Enter a valid rainfall value to calculate GPM.");
	}

	return (area * 144 * rainfall) / 231 / 60;
}
